import { useEffect, useState } from "react";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import useActionCreator from "@redux/hooks/useActionCreator";

import { VendorState } from "@reducers/types/procurements/vendor-state";
import { useParams } from "react-router-dom";

interface UseVendorById {
  vendorState: VendorState;
  handleQueryById: (id: string | number) => void;
}

export const useVendor = (isInitial: boolean = true): UseVendorById => {
  const params = useParams();
  const { vendorByIdFetchActionHandler } = useActionCreator();

  const [query, setQuery] = useState({
    isFetch: isInitial,
    id: `${params.id || ""}`,
  });

  const vendorState = useCustomSelector(
    (store) => store.procurements.vendorState,
  );

  const handleQueryById = (id: string | number) => {
    setQuery((prev) => {
      return {
        ...prev,
        id: `${id}`,
        isFetch: true,
      };
    });
  };

  useEffect(() => {
    if (query.isFetch && query.id) {
      vendorByIdFetchActionHandler(`${query.id}`);
    }
  }, [query]);

  return {
    vendorState,
    handleQueryById,
  };
};
